import PropTypes from 'prop-types';
import React from 'react';
import { ImageItemModelShape } from '@bingads-webui-react/image-picker'; //eslint-disable-line

const StockImageItemWrapper = (props) => {
  const {
    children,
    itemHeight,
    image,
    isSelected,
  } = props;

  const thumbnailHeight = itemHeight;
  const thumbnailWidth = Math.round((image.width * thumbnailHeight) / image.height);
  const limitedThumbnailWidth =
    thumbnailWidth / thumbnailHeight > 1.6 ? thumbnailHeight * 1.6 : thumbnailWidth;

  const wrapperStyle = {
    maxHeight: thumbnailHeight,
    height: thumbnailHeight,
    width: limitedThumbnailWidth,
    overflow: 'hidden',
    margin: '5px',
    border: isSelected ? '2px solid #0078D4' : 'none',
  };

  return (
    <div style={wrapperStyle} className="stock-image-wrapper">
      {children}
    </div>
  );
};

StockImageItemWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  image: ImageItemModelShape.isRequired,
  itemHeight: PropTypes.number.isRequired,
  isSelected: PropTypes.bool,
};

StockImageItemWrapper.defaultProps = {
  isSelected: false,
};

export default StockImageItemWrapper;
